<app-header class="fixed-header" [title]="LITERALS.SALES.TITTLE"></app-header>
<p-sidebar class="fixed-sidebar" styleClass="menu-filter" [modal]="false" (onShow)="onResize()" position="left">
</p-sidebar>

<div class="fixed-middle-bar">
  <div style="display: flex; flex-direction: row; align-items: center; width: 30%">
    <app-new-time-selector
      #calendar_selector
      [slctdDateOpt]="2"
      (initGetInfo)="emitGetInfo($event)"
      style="margin-top: 5%"
    ></app-new-time-selector>
    <svg
      class="movanoHeader_Tittle_btn"
      style="margin-left: 10%"
      width="max(1.11vw, 16px)"
      height="max(1.11vw, 16px)"
      *ngIf="(selectedTab === 'Sales' && !list && !searchDisplay) || (selectedTab === 'VIP' && !searchDisplay)"
      (click)="searchDisplay = true"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9167 9.66667H10.2583L10.025 9.44167C10.8417 8.49167 11.3333 7.25833 11.3333 5.91667C11.3333 2.925 8.90833 0.5 5.91667 0.5C2.925 0.5 0.5 2.925 0.5 5.91667C0.5 8.90833 2.925 11.3333 5.91667 11.3333C7.25833 11.3333 8.49167 10.8417 9.44167 10.025L9.66667 10.2583V10.9167L13.8333 15.075L15.075 13.8333L10.9167 9.66667V9.66667ZM5.91667 9.66667C3.84167 9.66667 2.16667 7.99167 2.16667 5.91667C2.16667 3.84167 3.84167 2.16667 5.91667 2.16667C7.99167 2.16667 9.66667 3.84167 9.66667 5.91667C9.66667 7.99167 7.99167 9.66667 5.91667 9.66667Z"
        fill="var(--main-blue-dark)"
      />
    </svg>
    <div
      style="margin-right: 20px; margin-left: 20px"
      *ngIf="searchDisplay"
      class="movanoHeader_Tittle_Search scale-up-hor-left"
    >
      <svg
        width="max(1.11vw, 16px)"
        height="max(1.11vw, 16px)"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        (click)="searchUser(searchInput.value)"
      >
        <path
          d="M10.9167 9.66667H10.2583L10.025 9.44167C10.8417 8.49167 11.3333 7.25833 11.3333 5.91667C11.3333 2.925 8.90833 0.5 5.91667 0.5C2.925 0.5 0.5 2.925 0.5 5.91667C0.5 8.90833 2.925 11.3333 5.91667 11.3333C7.25833 11.3333 8.49167 10.8417 9.44167 10.025L9.66667 10.2583V10.9167L13.8333 15.075L15.075 13.8333L10.9167 9.66667V9.66667ZM5.91667 9.66667C3.84167 9.66667 2.16667 7.99167 2.16667 5.91667C2.16667 3.84167 3.84167 2.16667 5.91667 2.16667C7.99167 2.16667 9.66667 3.84167 9.66667 5.91667C9.66667 7.99167 7.99167 9.66667 5.91667 9.66667Z"
          fill="var(--main-blue-dark)"
        />
      </svg>
      <span class="p-input-icon-left">
        <input
          class="movanoInputSearch"
          type="text"
          placeholder="Search user"
          #searchInput
          pInputText
          (keyup.enter)="searchUser(searchInput.value)"
        />
      </span>
      <svg
        width="max(0.833vw, 16px)"
        height="max(0.833vw, 16px)"
        (click)="clearSearch(); searchDisplay = false; this.isFiltered = false"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z"
          fill="#C4D9EE"
        />
      </svg>
    </div>
    <div class="empty-space"></div>
  </div>
  <app-tab-selector
    [tabs]="['Sales', 'RMAs', 'VIP']"
    (tabSelected)="onTabSelected($event)"
    (click)="searchDisplay = false"
    *ngIf="accountType !== 'customerSupport'"
  ></app-tab-selector>
  <app-tab-selector
    [tabs]="['Sales', 'VIP']"
    (tabSelected)="onTabSelected($event)"
    (click)="searchDisplay = false"
    *ngIf="accountType === 'customerSupport'"
  ></app-tab-selector>

  <div class="last">
    <span *ngIf="selectedTab === 'Sales' && !list" class="totalVips">{{ salesTotal }} sales</span>
    <span *ngIf="selectedTab === 'VIP'" class="totalVips">{{ vipsTotal }} users</span>
    <svg
      *ngIf="(selectedTab === 'Sales' && !list) || selectedTab === 'VIP'"
      style="margin-right: 30px; cursor: pointer"
      (click)="selectedTab === 'VIP' ? exportCSVVip() : exportCSV()"
      width="max(1.11vw, 17px)"
      height="max(1.11vw, 19px)"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.186 1.1897e-05H4.60464L3.00801 0L3 16C3 16 3.71406 16 4.59662 16H13.3953C14.2779 16 15 16 15 16V4.75109L10.186 1.1897e-05ZM13.3953 14.393H4.60464V1.53712H9.38372V5.55458H13.3953V14.393Z"
        fill="#054280"
      />
      <path d="M0 10H17V19H0V10Z" fill="#054280" />
      <path d="M12.8696 17L11.1546 12.1H12.1276L13.3316 15.775L14.5426 12.1H15.5156L13.7936 17H12.8696Z" fill="white" />
      <path
        d="M8.99207 17.105C8.57207 17.105 8.18474 17.014 7.83007 16.832C7.48007 16.6453 7.2024 16.3303 6.99707 15.887L7.76007 15.467C7.8954 15.7097 8.05874 15.8987 8.25007 16.034C8.4414 16.1693 8.7004 16.237 9.02707 16.237C9.34907 16.237 9.56374 16.1833 9.67107 16.076C9.7784 15.964 9.83207 15.817 9.83207 15.635C9.83207 15.5183 9.80407 15.418 9.74807 15.334C9.69674 15.25 9.58007 15.1707 9.39807 15.096C9.22074 15.0167 8.9454 14.9327 8.57207 14.844C8.1194 14.7367 7.78574 14.564 7.57107 14.326C7.3564 14.088 7.24907 13.7917 7.24907 13.437C7.24907 13.143 7.31907 12.8863 7.45907 12.667C7.59907 12.4477 7.79507 12.2773 8.04707 12.156C8.30374 12.03 8.60474 11.967 8.95007 11.967C9.2674 11.967 9.5474 12.016 9.79007 12.114C10.0327 12.212 10.2381 12.3403 10.4061 12.499C10.5787 12.6577 10.7141 12.8303 10.8121 13.017L10.0911 13.556C10.0211 13.444 9.93474 13.3343 9.83207 13.227C9.73407 13.115 9.61274 13.0217 9.46807 12.947C9.3234 12.8723 9.14607 12.835 8.93607 12.835C8.71674 12.835 8.53707 12.8817 8.39707 12.975C8.26174 13.0637 8.19407 13.2037 8.19407 13.395C8.19407 13.4697 8.21274 13.5467 8.25007 13.626C8.29207 13.7007 8.3854 13.7753 8.53007 13.85C8.6794 13.9247 8.91507 14.0017 9.23707 14.081C9.78307 14.2117 10.1774 14.4077 10.4201 14.669C10.6674 14.9257 10.7911 15.243 10.7911 15.621C10.7911 16.1017 10.6277 16.4703 10.3011 16.727C9.97907 16.979 9.54274 17.105 8.99207 17.105Z"
        fill="white"
      />
      <path
        d="M4.54096 17.119C4.09762 17.119 3.70096 17.014 3.35096 16.804C3.00096 16.594 2.72562 16.2977 2.52496 15.915C2.32896 15.5277 2.23096 15.0727 2.23096 14.55C2.23096 14.0227 2.32896 13.5677 2.52496 13.185C2.72562 12.7977 3.00096 12.499 3.35096 12.289C3.70096 12.0743 4.09762 11.967 4.54096 11.967C4.95629 11.967 5.32962 12.0603 5.66096 12.247C5.99696 12.4337 6.26529 12.695 6.46596 13.031L5.65396 13.5C5.53729 13.2947 5.38329 13.136 5.19196 13.024C5.00529 12.912 4.78829 12.856 4.54096 12.856C4.26562 12.856 4.02529 12.9283 3.81996 13.073C3.61929 13.213 3.46296 13.409 3.35096 13.661C3.23896 13.913 3.18296 14.2093 3.18296 14.55C3.18296 14.886 3.23896 15.18 3.35096 15.432C3.46296 15.684 3.61929 15.8823 3.81996 16.027C4.02529 16.167 4.26562 16.237 4.54096 16.237C4.78829 16.237 5.00529 16.181 5.19196 16.069C5.38329 15.9523 5.53729 15.7937 5.65396 15.593L6.46596 16.062C6.26529 16.3933 5.99696 16.6523 5.66096 16.839C5.32962 17.0257 4.95629 17.119 4.54096 17.119Z"
        fill="white"
      />
    </svg>
    <!-- Buttons to change beetween list and graphics -->
    <div class="image-buttons-container" *ngIf="accountType !== 'customerSupport'">
      <img
        *ngIf="selectedTab === 'Sales' && list"
        src="../../assets/buttonSalesList.svg"
        alt="Button 1"
        class="image-button"
        (click)="toggleList()"
        style="margin-right: 1.8em"
      />

      <img
        *ngIf="selectedTab === 'Sales' && !list"
        src="../../assets/buttonSalesGraphics.svg"
        alt="Button 2"
        class="image-button"
        (click)="toggleList()"
      />
    </div>
  </div>
</div>

<div *ngIf="selectedTab === 'Sales'" class="tab-container">
  <div *ngIf="list && accountType !== 'customerSupport'">
    <!-- Muestra el spinner si está cargando -->
    <div *ngIf="loadingSalesManagementList; else salesContent" class="spinner-container" style="position: absolute; top: 50%; left: 50%">
      <p-progressSpinner
      styleClass="{{ darkMode ? 'custom-spinner' : 'custom-spinner-blue' }}"
      strokeWidth="2"
      animationDuration="1.5s"
    >
    </p-progressSpinner>
    </div>

    <!-- Contenido principal que se muestra cuando no está cargando -->
    <ng-template #salesContent>
      <app-sales-header></app-sales-header>
      <div style="margin-left: 2%; margin-top: 20px; margin-right: 2%">
        <app-stats-widget-chart
          [dashboardType]="'SalesManagement'"
          style="margin-top: 1%"
          [showLegend]="true"
          [showAverage]="false"
          [showGrid]="false"
          [sleepStatUserActivity]="true"
          class="echart-big"
          [showImages]="false"
        >
        </app-stats-widget-chart>
      </div>
      <app-sales-donuts></app-sales-donuts>
    </ng-template>
  </div>

  <!-- List Sales -->
  <div *ngIf="!list" class="movanoUsers">
    <div [ngStyle]="{ display: !loadingSalesManagementList ? 'block' : 'none' }" class="movanoTableBox">
      <p-table
        id="userTable"
        #userTable
        class="movano-Table"
        [globalFilterFields]="[
          'salesDate',
          'poNumber',
          'soNumber',
          'soUserName',
          'flgVip',
          'dateFulFilledDevice',
          'memo',
          'deviceSerialNumber',
          'flgReplacementSo',
          'flgSentToShipment',
          'trackingNumbers'
        ]"
        [value]="salesManagement"
        [paginator]="true"
        [rows]="rows"
        [first]="pageSelected"
        [scrollable]="true"
        scrollHeight="75vh"
      >
        <ng-template pTemplate="header">
          <tr [ngClass]="'movanoTable_Header'">
            <th (click)="toggleSort('salesDate')">
              Date Created
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'salesDate' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'salesDate' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <th (click)="toggleSort('poNumner')">
              PO number
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'poNumner' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'poNumner' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <th (click)="toggleSort('soNumber')">
              SO number
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'soNumber' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'soNumber' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <th (click)="toggleSort('soUserName')">
              Customer name
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'soUserName' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'soUserName' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <th (click)="toggleSort('flgVip')">
              Vip
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'flgVip' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'flgVip' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <th (click)="toggleSort('dateFulFilledDevice')">
              Date Fulfilled
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform:
                    sortMode === 'asc' && sortedBy === 'dateFulFilledDevice' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'dateFulFilledDevice' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <!-- <th (click)="toggleSort('rmaType')">
              exchange order
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'rmaType' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'rmaType' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th> -->
            <th (click)="toggleSort('memo')">
              Item description
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'memo' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'memo' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <th (click)="toggleSort('deviceSerialNumber')">
              Serial number
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'deviceSerialNumber' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'deviceSerialNumber' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <th (click)="toggleSort('flgReplacementSo')">
              Exchange
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'flgReplacementSo' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'flgReplacementSo' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <th (click)="toggleSort('flgSentToShipment')">
              Sent to ship
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'flgSentToShipment' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'flgSentToShipment' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <th (click)="toggleSort('trackingNumbers')">
              Tracking number
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'trackingNumbers' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'trackingNumbers' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-sales let-i="rowIndex">
          <tr
            [ngStyle]="{
              background: darkMode ? (i % 2 == 0 ? '#05294d' : '#05305B') : i % 2 == 0 ? '#f3f6f9' : 'white'
            }"
            [ngClass]="'movanoTable_Obj'"
          >
            <td>{{ sales.salesDate | date : "MM/dd/yy" }}</td>
            <td>{{ sales.poNumber }}</td>
            <td [ngClass]="'bold-text'">{{ sales.soNumber }}</td>
            <td>{{ sales.soUserName }}</td>
            <td [ngClass]="{ 'text-danger': !sales.flgVip, 'text-success': sales.flgVip }">
              {{ sales.flgVip ? "Yes" : "No" }}
            </td>
            <td>{{ sales.dateFulFilledDevice | date : "MM/dd/yy" }}</td>
            <td>{{ sales.memo }}</td>
            <td>{{ sales.deviceSerialNumber ? sales.deviceSerialNumber : sales.sizerKitSerialNumber }}</td>
            <td [ngClass]="{ 'text-danger': !sales.flgReplacementSo, 'text-success': sales.flgReplacementSo }">
              {{ sales.flgReplacementSo ? "Yes" : "No" }}
            </td>
            <td [ngClass]="{ 'text-danger': !sales.flgSentToShipment, 'text-success': sales.flgSentToShipment }">
              {{ sales.flgSentToShipment ? "Yes" : "No" }}
            </td>

            <td>{{ sales.trackingNumbers }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="paginatorright" let-state>
          <div class="movanoPaginator">
            <svg (click)="previousPage()" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.3333 5.33335L3.21996 5.33335L6.94663 1.60669L5.99996 0.666687L0.666626 6.00002L5.99996 11.3334L6.93996 10.3934L3.21996 6.66669L11.3333 6.66669V5.33335Z"
                [ngStyle]="{ fill: state.page > 0 ? '#0B84FF' : '#AABED3' }"
              />
            </svg>

            <button
              *ngIf="!isFirstPageInRange()"
              (click)="selectPage(1)"
              [ngClass]="{ 'active-page': actualPage === 1 }"
            >
              1
            </button>

            <svg *ngIf="shouldShowLeftEllipsis()" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="18" height="8" rx="4" fill="#C4D9EE" />
              <circle cx="9" cy="4" r="1" fill="var(--main-blue-dark)" />
              <circle cx="13" cy="4" r="1" fill="var(--main-blue-dark)" />
              <circle cx="5" cy="4" r="1" fill="var(--main-blue-dark)" />
            </svg>

            <button
              *ngFor="let page of getDisplayedPages()"
              [ngClass]="{ 'active-page': page === actualPage }"
              (click)="selectPage(page)"
            >
              {{ page }}
            </button>

            <svg *ngIf="shouldShowRightEllipsis()" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="18" height="8" rx="4" fill="#C4D9EE" />
              <circle cx="9" cy="4" r="1" fill="var(--main-blue-dark)" />
              <circle cx="13" cy="4" r="1" fill="var(--main-blue-dark)" />
              <circle cx="5" cy="4" r="1" fill="var(--main-blue-dark)" />
            </svg>

            <button
              *ngIf="!isLastPageInRange()"
              (click)="selectPage(totalPages)"
              [ngClass]="{ 'active-page': actualPage === totalPages }"
            >
              {{ totalPages }}
            </button>

            <svg (click)="nextPage()" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.666647 6.66665L8.77998 6.66665L5.05331 10.3933L5.99998 11.3333L11.3333 5.99998L5.99998 0.666646L5.05998 1.60665L8.77998 5.33331L0.666647 5.33331L0.666647 6.66665Z"
                [ngStyle]="{ fill: state.page < state.pageCount - 1 ? '#0B84FF' : '#AABED3' }"
              />
            </svg>
          </div>
        </ng-template>
      </p-table>
      <div id="mobileScroll" class="movanoTableBox_mobileShadow"></div>
      <div id="mobileScroll_Left" class="movanoTableBox_mobileShadow movanoTableBox_mobileShadow_Left"></div>
    </div>
  </div>
  <div *ngIf="loadingSalesManagementList" style="position: absolute; top: 50%; left: 50%">
    <p-progressSpinner
      styleClass="{{ darkMode ? 'custom-spinner' : 'custom-spinner-blue' }}"
      strokeWidth="2"
      animationDuration="1.5s"
      *ngIf="selectedTab === 'Sales' && !list"
    >
    </p-progressSpinner>
  </div>
</div>
<div *ngIf="selectedTab === 'RMAs'">
  <app-rmas-header></app-rmas-header>
  <div style="margin-left: 2%; margin-top: 20px; margin-right: 2%">
    <app-stats-widget-chart
      [dashboardType]="'RMAs'"
      style="margin-top: 1%"
      [showLegend]="true"
      [showAverage]="false"
      [showGrid]="false"
      [sleepStatUserActivity]="true"
      class="echart-big"
      [showImages]="false"
    >
    </app-stats-widget-chart>
  </div>
  <app-rmas-donuts></app-rmas-donuts>
</div>

<div class="movanoUsers" *ngIf="selectedTab === 'VIP'">
  <!-- <app-vip-tap></app-vip-tap> -->
  <div class="movanoUsers">
    <div [ngStyle]="{ display: !loadingVipManagementList ? 'block' : 'none' }" class="movanoTableBox">
      <p-table
        id="userTable"
        #userTable
        class="movano-Table"
        [globalFilterFields]="[
          'soNumber',
          'soUserName',
          'memo',
          'flgSentToShipment',
          'trackingNumbers',
          'productSizeId',
          'productColorId',
          'salesDate'
        ]"
        [value]="vipsManagement"
        [paginator]="true"
        [rows]="rows"
        [first]="pageSelected"
        [scrollable]="true"
        scrollHeight="75vh"
      >
        <ng-template pTemplate="header">
          <tr [ngClass]="'movanoTable_Header'">
            <th (click)="toggleSort('soNumber')">
              Document Number
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'soNumber' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'soNumber' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <th (click)="toggleSort('soUserName')">
              Name
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'soUserName' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'soUserName' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <th (click)="toggleSort('memo')">
              Description
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'memo' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'memo' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <th (click)="toggleSort('flgSentToShipment')">
              Sent to shipment partner
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'flgSentToShipment' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'flgSentToShipment' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <th (click)="toggleSort('trackingNumbers')">
              Tracking Number
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'trackingNumbers' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'trackingNumbers' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <th (click)="toggleSort('productSizeId')">
              Size
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'productSizeId' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'productSizeId' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <th (click)="toggleSort('productColorId')">
              Color
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'productColorId' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'productColorId' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
            <th (click)="toggleSort('salesDate')">
              Creation Date
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'salesDate' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'salesDate' ? '#05428f' : '#C4D9EE'"
                />
              </svg>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-vips let-i="rowIndex">
          <tr
            [ngStyle]="{
              background: darkMode ? (i % 2 == 0 ? '#05294d' : '#05305B') : i % 2 == 0 ? '#f3f6f9' : 'white'
            }"
            [ngClass]="'movanoTable_Obj'"
          >
            <td>{{ vips.soNumber }}</td>
            <td>{{ vips.soUserName }}</td>
            <td>{{ vips.memo }}</td>
            <td [ngClass]="{ 'text-success': vips.flgSetToShipment, 'text-danger': !vips.flgSetToShipment }">
              {{ vips.flgSetToShipment ? "Yes" : "No" }}
            </td>
            <td>{{ vips.trackingNumbers }}</td>
            <td [ngStyle]="getSizeColorStyle(vips.productSize)">
              {{ vips.productSize }}
            </td>
            <td [ngStyle]="getColorStyle(vips.productColor)">
              {{ vips.productColor }}
            </td>
            <td>{{ vips.salesDate | date : "MM/dd/yy" }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="paginatorright" let-state>
          <div class="movanoPaginator">
            <svg (click)="previousPageVip()" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.3333 5.33335L3.21996 5.33335L6.94663 1.60669L5.99996 0.666687L0.666626 6.00002L5.99996 11.3334L6.93996 10.3934L3.21996 6.66669L11.3333 6.66669V5.33335Z"
                [ngStyle]="{ fill: state.page > 0 ? '#0B84FF' : '#AABED3' }"
              />
            </svg>

            <svg *ngIf="shouldShowLeftEllipsisVip()" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="18" height="8" rx="4" fill="#C4D9EE" />
              <circle cx="9" cy="4" r="1" fill="var(--main-blue-dark)" />
              <circle cx="13" cy="4" r="1" fill="var(--main-blue-dark)" />
              <circle cx="5" cy="4" r="1" fill="var(--main-blue-dark)" />
            </svg>

            <button
              *ngFor="let page of getDisplayedPagesVip()"
              [ngClass]="{ 'active-page': page === actualPageVip }"
              (click)="selectPageVip(page)"
            >
              {{ page }}
            </button>

            <svg (click)="nextPageVip()" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.666647 6.66665L8.77998 6.66665L5.05331 10.3933L5.99998 11.3333L11.3333 5.99998L5.99998 0.666646L5.05998 1.60665L8.77998 5.33331L0.666647 5.33331L0.666647 6.66665Z"
                [ngStyle]="{ fill: state.page < state.pageCount - 1 ? '#0B84FF' : '#AABED3' }"
              />
            </svg>
          </div>
        </ng-template>
      </p-table>
      <div id="mobileScroll" class="movanoTableBox_mobileShadow"></div>
      <div id="mobileScroll_Left" class="movanoTableBox_mobileShadow movanoTableBox_mobileShadow_Left"></div>
    </div>
  </div>
  <div *ngIf="loadingVipManagementList" style="position: absolute; top: 50%; left: 50%">
    <p-progressSpinner
      styleClass="{{ darkMode ? 'custom-spinner' : 'custom-spinner-blue' }}"
      strokeWidth="2"
      animationDuration="1.5s"
    >
    </p-progressSpinner>
  </div>
</div>
